import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';

const useDeleteToken = () => {
  const queryClient = useQueryClient();

  const deleteToken = async (token_id: string) => {
    const response = await Axios.delete(DELETE_URL(token_id).deleteToken);
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, string>(
    (token_id: string) => deleteToken(token_id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tokens']);
      },
      useErrorBoundary: false
    }
  );
};

export default useDeleteToken;
